import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { HelmetProvider } from "react-helmet-async"; // Import HelmetProvider
import LanguageProvider from "./LanguageContext"; // Correct import for default export

ReactDOM.render(
  <LanguageProvider>
     <HelmetProvider>
    <App />
    </HelmetProvider>
  </LanguageProvider>,
  document.getElementById("root")
);
